import template from './index.html'

const switcher = (params) => {
  return {
    id: params.id,
    checked: params.checked || 0,
    onChange: params.onChange || (_ => {}),
    async init() {
        this.$nextTick(_ => {
          this.$el.innerHTML = template
        })
    }
  }
}

export { switcher };
